import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators} from 'redux';
import { actionCreators } from '../../store/Location';
import {withRouter} from "react-router-dom";
import Breadcrumb from "../BreadcrumbMenu";
import TabMenu from "./TabMenu/TabMenu";

class LocationDetail extends Component{
  constructor(props) {
    super(props);
    this.state = {
      
    };

    this.handleBack = this.handleBack.bind(this);
  }

  componentDidMount(){
    if (this.props.match) {
      const id = this.props.match.params.id;
      this.props.selectLocation(id);
    }
  }
  
  componentWillUnmount(){
  };
  
  handleBack(){
    this.props.history.goBack();
  }

  render(){
    if (!this.props.current){
      return (null);
    } else {
      return(
        <div>
          <Breadcrumb baseClass={"Locations"} current={this.props.current.fileMakerId}/>
          
          {/*Location Detail Container*/}
          <div className="centered-container border">
            <div className="container-body">
              <div className="detail">
                <div className="detail-row">
                  <div className="row-item">
                    <h3>{this.props.current.name}</h3>
                  </div>
                  {this.props.current.status ?
                    <div className="row-item">
                      <div className="pill-blue">
                        {this.props.current.status}
                      </div>
                    </div>
                    :""
                  }
                  {this.props.current.flagShip ?
                    <div className="row-item">
                      <div className="pill-red">
                        Fl
                      </div>
                    </div>
                    :""
                  }
                </div>
                <div className="detail-row">
                  <p className="label font-md">{this.props.current.address} <br />{this.props.current.city}, {this.props.current.state}</p>
                </div>
                <div className="detail-row">
                  <div className="row-item">
                    <span className="icon-person"/>
                  </div>
                  <div className="row-item">
                    <p className="label">{this.props.current.storeContact || '---'}</p>
                  </div>
                  <div className="row-item">
                    <span className="icon-phone"/>
                  </div>
                  <div className="row-item">
                    <p className="label">{this.props.current.phoneNumber || '---'}</p>
                  </div>
                  <div className="row-item">
                    <span className="icon-print"/>
                  </div>
                  <div className="row-item">
                    <p className="label">{this.props.current.faxNumber || '---'}</p>
                  </div>
                  <div className="row-item">
                    <span className="icon-email"/>
                  </div>
                  <div className="row-item">
                    <p className="label">{this.props.current.emailAddress || '---'}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <TabMenu locid={this.props.match.params.id} key={this.props.match.params.id}/>
          
        </div>
      );
    }

  }

}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user,
    current: state.locations.current,
  }
};

export default withRouter(connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(LocationDetail));